import React, { useEffect, useState } from "react";
import * as cls from "./calendarGraphic.module.scss";
import CourseDetail from "../courseDetail/CourseDetail";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  ErrataView,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import { StudentService } from "../studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
function CalendarGraphicWidget({ menu }) {
  const { contractId } = useSelector((state) => state.contract);
  const [courses, setCourses] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { access_token } = useSelector((state) => state.token);
  const [errorMessage, setErrorMessage] = useState(null);

  async function getCalendarGraphic() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/widget/calendar_graphic",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          setErrorMessage(response);
          if (!response.errors) {
            response.forEach((course, idx) => {
              if (course.is_current_course) {
                setCurrentIndex(idx);
              }
            });
            setCourses(response);
          } else {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
            return;
          }
        }
      });
    }
  }
  function changeCourseBack() {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  }
  function changeCourseForward() {
    if (currentIndex < courses.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  }
  useEffect(() => {
    getCalendarGraphic();
  }, [contractId]);

  if (errorMessage && errorMessage.errors) {
    return (
      <WidgetFrame type="blue" icon="survey" title="Планирование" menu={menu}>
        {errorMessage.error_type === "info" ? (
          <ErrataViewInfo errata={errorMessage} />
        ) : (
          <ErrataView errata={errorMessage} />
        )}
      </WidgetFrame>
    );
  }
  if (courses === null || courses?.errors || courses.length === 0) {
    return (
      <WidgetFrame
        type="blue"
        icon="survey"
        title="Планирование"
        menu={menu}
      ></WidgetFrame>
    );
  }

  return (
    <WidgetFrame type="blue" icon="survey" title="Планирование" menu={menu}>
      <div className={cls.tableContainer}>
        <div className={cls.tableHeader}>
          <div
            onClick={changeCourseBack}
            disabled={currentIndex === 0}
            className={`${
              currentIndex === 0 ? cls.disabledBth : cls.btnContainer
            }`}
          >
            {/* {currentIndex !== 0 && ( */}
            <ArrowBackIosIcon sx={{ width: "0.75rem" }} />
            {/* )} */}
            <div disabled={currentIndex === 0}>
              {currentIndex > 0
                ? courses[currentIndex - 1].name
                : courses[currentIndex].name}
            </div>
          </div>
          <div className={cls.currentCourse}>
            <div className={cls.currentCourseName}>
              {courses[currentIndex].name} /
            </div>
            <div className={cls.currentCourseYear}>
              {new Date(courses[currentIndex].start_date).getFullYear()}-
              {new Date(courses[currentIndex].end_date).getFullYear()}
            </div>
          </div>
          <div
            onClick={changeCourseForward}
            disabled={currentIndex === courses.length - 1}
            className={`${
              currentIndex === courses.length - 1
                ? cls.disabledBth
                : cls.btnContainer
            }`}
          >
            <div disabled={currentIndex === courses.length - 1}>
              {currentIndex < courses.length - 1
                ? courses[currentIndex + 1].name
                : courses[currentIndex].name}
            </div>
            <ArrowForwardIosIcon sx={{ width: "0.75rem" }} />
          </div>
        </div>
        <CourseDetail course={courses[currentIndex]} />
      </div>
    </WidgetFrame>
  );
}

export default CalendarGraphicWidget;
